<template>
  <div class="ma-class">
    <Header></Header>
    <div class="class-content max-w">
      <div class="back" @click="$router.push(`/${schoolcode}/student`)">
        返回
      </div>
      <div class="class-info">
        <div class="practice-name">
          {{ classInfo.activity_name }}
        </div>
        <div class="class-name">班级名称： {{ classInfo.name }}</div>
        <div class="class-teach">负责老师：{{ classInfo.teacher_name }}</div>
      </div>
      <div class="class-title">班级学生</div>
      <div class="class-table">
        <table>
          <thead>
            <tr>
              <th>账号</th>
              <th>姓名</th>
              <th>手机号</th>
              <th>加入时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in classList" :key="ind">
              <td>{{ item.username }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.created_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <a-pagination
        v-if="total > pageSize"
        v-model="memberPage"
        :total="total"
        :page-size="pageSize"
        show-less-items
        @change="MemberChange"
      />
    </div>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import "../../assets/css/student.less";
import services from "../../assets/js/services.js";
import loading from "../../components/loading.vue";

export default {
  components: {
    Header,
    loading,
  },
  data() {
    return {
      schoolcode: localStorage.getItem("schoolCode"),
      classInfo: {},
      pageSize: 10,
      memberPage: 0,
      total: 0,
      classList: [],
      classId: "",
      activityId: "",
      loading: false,
    };
  },
  created() {
    this.classId = this.$route.query.classes;
    this.activityId = this.$route.query.activity_id;
    this.getCenterActivityClasses();
    this.getActivityClassesMember(1);
  },
  methods: {
    async getCenterActivityClasses() {
      let res = await services.getCenterActivityClasses(
        {
          // classes: this.classId,
          activity_id: this.activityId,
        },
        this.classId
      );
      if (res.code == "0000") {
        this.classInfo = res.data;
      }
    },
    async getActivityClassesMember(page) {
      this.loading = true;
      this.memberPage = page;
      let res = await services.getActivityClassesMember({
        page: page,
        size: this.pageSize,
        activity_id: this.activityId,
        class_id: this.classId,
      });
      if (res.code == "0000") {
        this.classList = res.data.items;
        this.total = res.data.total;
      }
      this.loading = false;
    },
    MemberChange(page) {
      this.getActivityClassesMember(page);
    },
  },
};
</script>
<style lang="less" scoped>
.ma-class {
  padding-top: 60px;
  .class-content {
    margin: 0 auto;
    padding-top: 16px;
    .back {
      width: 80px;
      height: 32px;
      cursor: pointer;
      background: #b84b3c;
      border-radius: 16px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 32px;
      &::before {
        content: "<";
        margin-right: 5px;
      }
    }
    .class-info {
      margin-top: 16px;
      height: 40px;
      background: linear-gradient(90deg, #ffefcc 0%, #ffebd3 100%);
      border-radius: 4px 4px 0px 0px;
      line-height: 40px;
      display: flex;
      padding: 0 25px;
      .practice-name {
        font-weight: bold;
        font-size: 16px;
        color: #6f4113;
        margin-right: 19%;
      }
      .class-name {
        font-weight: bold;
        font-size: 14px;
        color: #373536;
      }
      .class-teach {
        font-weight: bold;
        font-size: 14px;
        color: #373536;
        margin-left: 8%;
      }
    }
    .class-title {
      font-weight: bold;
      font-size: 14px;
      color: #373536;
      text-align: center;
      letter-spacing: 5px;
      margin-top: 20px;
    }
    .class-table {
      margin-top: 21px;
      table {
        width: 100%;
        thead {
          tr {
            background: #f8f8f8;
            th {
              padding: 0 24px;
              font-weight: bold;
              font-size: 14px;
              color: #2f2626;
              height: 36px;
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid #ecedef;
            td {
              font-size: 14px;
              color: #717479;
              line-height: 36px;
              padding: 0 24px;
            }
          }
        }
      }
    }
  }
}
/deep/.ant-pagination {
  margin-top: 15px;
  text-align: center;
  .ant-pagination-item-active {
    font-weight: 500;
    background: #b84b3c;
    border-color: #b84b3c;
  }

  .ant-pagination-item-active:focus,
  .ant-pagination-item-active:hover,
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: #b84b3c;
    transition: all 0.3s;
    color: #fff;
  }

  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a {
    color: #b84b3c;
  }

  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a {
    color: #fff;
  }

  .ant-pagination-item-active a {
    color: #fff;
    border-color: #b84b3c;
  }

  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #b84b3c;
    border-color: #b84b3c;
  }
}
</style>